import { useContext } from 'react';
import styles from './SearchBarButton.module.scss';
import { SearchIcon } from '../../icons/Icons';
import { AppContext } from '../../../context/AppContext';
import { useHistory } from 'react-router-dom';
import { RouteWithState } from '../../../lib/util';

const SearchBarButton = () => {
  const appContext = useContext(AppContext);
  const { planCode, chosenSpecialty, location, name, directoryListType, isDisabled, distance } = appContext;
  const history = useHistory();

  const handleSearch = () => {
    if (!isDisabled) {
      //console.log('SPEC: ', chosenSpecialty)
      
      //Does this do anything?

      //  const path = RouteWithState(
      //     `/results/${planCode}/phone/${name || 'undefined'}`,
      //     appContext
      //   );
      
      const path = RouteWithState(
        `/results/${planCode}/${directoryListType}/${chosenSpecialty || 'undefined'}/${name || 'undefined'}/${location || 'undefined'}?distance=${distance.distance}&_t=${Date.now()}`,
        appContext
      );
      

      history.push(path);

      
    }
  };

  return (
    <>
      <div className="showDesktop">
        <div style={{ display: 'flex', justifyContent: 'flex-end', height: '100%' }}>
          <button disabled={isDisabled} className={isDisabled ? styles.searchButtonDisabled : styles.searchButton} onClick={() => handleSearch()}>
            <span className={`${styles.icon} ${styles.baseline}`}>
              <SearchIcon />
            </span>
          </button>
        </div>
      </div>

      <button type="button" disabled={isDisabled} className={isDisabled ? 'button-search-mobile-disabled showMobile' : 'showMobile button-search-mobile'} onClick={() => handleSearch()}>
        Search
      </button>
    </>
  );
};

export default SearchBarButton;
